import React, { useState, useEffect } from 'react';

import TitlePage from '@/components/TitlePage';
import Card from '@/components/Card';
import Voucher from '@/components/Voucher';
import Badge from '@/components/Badge';
import sub from 'date-fns/sub';
import add from 'date-fns/add';
import { format, isAfter, parseISO, isValid, endOfDay } from 'date-fns';
import { pt } from 'date-fns/esm/locale';
import formatISO from 'date-fns/formatISO';

import {
    RiArrowDropDownLine,
    RiCheckboxBlankCircleLine,
    RiCheckboxCircleLine,
    RiShoppingCartLine,
    RiMoneyDollarCircleLine,
    RiShoppingBagLine,
    RiLineChartLine,
    RiEyeLine,
    RiEyeOffLine,
} from 'react-icons/ri';
import {
    BoxForm,
    HeaderSales,
    ArrowCollapse,
    ContainerLoader,
    CollapseItem,
    StudentContainer,
    VoucherContainer,
    ResponsibleContainer,
    Products,
    FooterSale,
    ItemSale,
    CardFilter,
    Installments,
    PaginationContainer,
    ContainerStats,
    CardStat
} from './styles';
import { translate } from '@/i18n/src/locales';
import { Helmet } from 'react-helmet';
import SelectOne from '@/components/Forms/SelectOne';
import ContentLoader from 'react-content-loader';
import { useSelector, useDispatch } from 'react-redux';

import { fetchPoles } from '@/store/actions/pole';
import { fetchSales, setFilterSales, clearSales, fetchAllSalesStatus, fetchAllSalesFranchisor, fetchAllSalesFranchisorPagination, fetchAllSalesStatisticFranchisor } from '@/store/actions/sales';
import { apiLoja } from '@/services/api';

import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { showAlert } from '@/store/actions/theme';
import Input from '@/components/Forms/Input';
import InputCPFCNPJ from '@/components/Forms/InputCPF-CNPJ';
import { exportToExcel } from '../../../utils/exportToExcel';
import SelectMulti from '../../../components/Forms/SelectMulti';

function Sales() {
    registerLocale('pt', pt);

    const poles = useSelector((state) => state.pole.poles);
    const sales = useSelector((state) => state.sales.sales);
    const salesPagination = useSelector((state) => state.sales.salesPagination);
    const {
        TotalPedidos,
        ValorTotalPedidos,
        TotalProdutos,
        TicketMedio
    } = useSelector((state) => state.sales.salesStatistic);
    const salesIsLoading = useSelector((state) => state.sales.salesIsLoading);
    const salesPaginationIsLoading = useSelector(state => state.sales.salesPaginationIsLoading);

    const filters = useSelector((state) => state.sales.filters);
    const filterCurrent = useSelector((state) => state.sales.filterCurrent);

    const dispatch = useDispatch();

    const [inputPoles, setInputPoles] = useState([]);
    const [endDate, setEndDate] = useState(null);
    const salesStatus = useSelector((state) => state.sales.salesStatus);
    const [orderCode, setOrderCode] = useState('');
    const [customerName, setCustomerName] = useState('');
    const [cpfCNPJ, setCPFCNPJ] = useState('');

    const inputDates = [
        { label: 'Últimos 7 dias', value: formatISO(sub(new Date(), { days: 7 }), { representation: "date" }) },
        { label: 'Últimos 30 dias', value: formatISO(sub(new Date(), { days: 30 }), { representation: "date" }) },
        { label: 'Últimos 90 dias', value: formatISO(sub(new Date(), { days: 90 }), { representation: "date" }) },
    ];

    const inputSaleType = [
        { label: translate('all'), value: 2 },
        { label: translate('sale'), value: 0 },
        { label: translate('expedition'), value: 1 },
    ];

    const inputShipmentType = [
        { label: translate('all'), value: 2 },
        { label: translate('automatic'), value: 1 },
        { label: translate('manual'), value: 0 },
    ];

    const [selectedDate, setSelectedDate] = useState(null);
    const [initialDate, setInitialDate] = useState(null);
    const [selectedPoles, setSelectedPoles] = useState([]);
    const [inputSaleStatus, setInputSaleStatus] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState([]);
    const [isExporting, setIsExporting] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [showValues, setShowValues] = useState(true);

    const [selectedSaleType, setSelectedSaleType] = useState(inputSaleType[0]);
    const [saleType, setSaleType] = useState(inputSaleType[0].value);

    const [selectedShipmentType, setSelectedShipmentType] = useState(inputShipmentType[0]);
    const [shipmentType, setShipmentType] = useState(inputShipmentType[0].value);

    const inputPaymentStatus = [
        { label: 'Processando', value: '1' },
        { label: 'Autorizada', value: '2' },
        { label: 'Paga', value: '3' },
        { label: 'Estornada', value: '4' },
        { label: 'Aguardando pagamento', value: '5' },
        { label: 'Aguardando estorno', value: '6' },
        { label: 'Não autorizado', value: '7' },
        { label: 'Cancelada', value: '8' },
        { label: 'Não gerado', value: '9' },
        { label: 'Pedido Efetuado', value: '10' },
        { label: 'Capturada', value: '11' },
        { label: 'Gerado', value: '12' },
        { label: 'Cancelado', value: '13' },
        { label: 'Não autorizado', value: '14' },
        { label: 'Falha', value: '15' },
        { label: 'Pendente', value: '16' },
    ];
    const [selectedPaymentStatus, setSelectedPaymentStatus] = useState([]);

    const salesList = salesPagination?.VendasFranqueadora || [];
    const totalPages = salesPagination?.QtdPaginas || 0;

    const currentSales = salesList;

    const formatCurrency = (value) => {
        return value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
    };

    useEffect(() => {
        dispatch(clearSales());

        const codeOrder = !orderCode ? "0" : orderCode;
        let dateEnd = null;

        if (filterCurrent.id === 1) {
            dateEnd = formatISO(new Date(), { representation: "date" });
        }

        if (filterCurrent.id === 2) {
            dateEnd = endDate;

            const past = isAfter(initialDate, endDate);
            if (past) {
                dispatch(
                    showAlert({
                        type: 'danger',
                        message: 'Data inicial maior que data final',
                        time: 3000,
                    }),
                );
                return;
            }
        }

        dispatch(fetchAllSalesFranchisorPagination(1, 20, selectedPoles, selectedStatus, codeOrder, initialDate, dateEnd, '', '', saleType, shipmentType, selectedPaymentStatus));
        dispatch(fetchAllSalesStatisticFranchisor(selectedPoles, selectedStatus, codeOrder, initialDate, dateEnd, '', '', saleType, shipmentType, selectedPaymentStatus));
        dispatch(fetchPoles());
        dispatch(fetchAllSalesStatus());

        let selected = filters.filter((item) => {
            if (item.active === true) {
                return item;
            }
        })[0];
    }, []);

    useEffect(() => {
        if (poles && poles.length > 0) {
            setInputPoles([
                ...poles.map((item) => ({
                    label: `${item.codigoExternoPolo} - ${item.nomePolo}`,
                    value: String(item.idPolo),
                })),
            ]);
        }
    }, [poles]);

    useEffect(() => {
        if (salesStatus && salesStatus.length > 0) {
            setInputSaleStatus([
                ...salesStatus.map((item) => ({
                    label: item.StatusVenda,
                    value: String(item.IdVendaStatus),
                })),
            ]);
        }
    }, [salesStatus]);


    const handleClearFilter = () => {
        setInitialDate(null);
        setSelectedDate(null);
        setEndDate(null);
        setSelectedStatus([]);
        setSelectedPoles([]);
        setOrderCode('');
        setCustomerName('');
        setSelectedSaleType(inputSaleType[0]);
        setSaleType(inputSaleType[0].value);
        setSelectedShipmentType(inputShipmentType[0]);
        setShipmentType(inputShipmentType[0].value);
        setCPFCNPJ('');
        setSelectedPaymentStatus([]);
        dispatch(clearSales());
    };

    const handleFechAllSales = async (exportarPlanilha) => {
        const codeOrder = !orderCode ? "0" : orderCode;
        let dateEnd = null;

        if (filterCurrent.id === 1) {
            dateEnd = formatISO(new Date(), { representation: "date" });
        }

        if (filterCurrent.id === 2) {
            dateEnd = endDate;

            const past = isAfter(initialDate, endDate);
            if (past) {
                dispatch(
                    showAlert({
                        type: 'danger',
                        message: 'Data inicial maior que data final',
                        time: 3000,
                    }),
                );
                return;
            }
        }

        return await dispatch(fetchAllSalesFranchisor(selectedPoles, selectedStatus, codeOrder, initialDate, dateEnd, exportarPlanilha, customerName, cpfCNPJ.replace(/\D/g, ''), saleType, shipmentType, selectedPaymentStatus));
    }

    const handleFetchPaginado = (pageNumber) => {
        if (salesPaginationIsLoading) return;

        setCurrentPage(pageNumber);

        const codeOrder = !orderCode ? "0" : orderCode;
        let dateEnd = null;
        let dataFim = null;

        if (filterCurrent.id === 1) {
            dateEnd = formatISO(new Date(), { representation: "date" });
            dataFim = endOfDay(dateEnd);
        }

        if (filterCurrent.id === 2) {
            dateEnd = endDate;

            const past = isAfter(initialDate, endDate);
            if (past) {
                dispatch(
                    showAlert({
                        type: 'danger',
                        message: 'Data inicial maior que data final',
                        time: 3000,
                    }),
                );
                return;
            }
        }

        dispatch(fetchAllSalesFranchisorPagination(
            pageNumber,
            20,
            selectedPoles,
            selectedStatus,
            codeOrder || 0,
            initialDate,
            dateEnd,
            customerName,
            cpfCNPJ.replace(/\D/g, ''),
            saleType,
            shipmentType,
            selectedPaymentStatus
        ));

        dispatch(fetchAllSalesStatisticFranchisor(selectedPoles, selectedStatus, codeOrder, initialDate, dateEnd, customerName, cpfCNPJ.replace(/\D/g, ''), saleType, shipmentType, selectedPaymentStatus));

        window.scrollTo(0, 0);
    };

    //#region handler filter
    function handleFilter(id) {

        if (id === 1) {
            setSelectedDate(inputDates[0]);
            setInitialDate(inputDates[0].value);
        } else {
            setInitialDate(null);
            setEndDate(null);
            setSelectedDate(null);
        }

        let _filters = filters.map((item) => {


            if (item.id === id) {
                return { ...item, active: true };
            } else {
                return { ...item, active: false };
            }
        });

        dispatch(setFilterSales(_filters));
    }

    const handleExport = async () => {
        try {
            dispatch(
                showAlert({
                    type: 'info',
                    message: translate('generatingSpreadsheet'),
                    time: 3000,
                }),
            );

            setIsExporting(true);
            const dataToExport = [];
            const merges = [];
            const vendas = await handleFechAllSales(1);

            // Ordenar por IdExpedicao (nulls ao final)
            vendas.sort((a, b) => {
                if (a.IdExpedicao === b.IdExpedicao) return 0;
                if (a.IdExpedicao === null) return 1;
                if (b.IdExpedicao === null) return -1;
                return a.IdExpedicao - b.IdExpedicao;
            });

            let currentRow = 1; // Linha 0 é o cabeçalho

            vendas.forEach(venda => {
                const startRow = currentRow;
                venda.VendaItem.forEach((item) => {
                    const valorProduto = item.TotalCalculado || 0;
                    const quantidade = item.Quantidade || 1;
                    const valorFrete = venda.Frete || 0;

                    const valorUnitario = valorProduto / quantidade;

                    dataToExport.push({
                        [translate('idExpedition')]: venda.IdExpedicao || '-',
                        [translate('order')]: venda.IdVenda,
                        [translate('omieOrder')]: venda.CodigoExternoIntegracao || '-',
                        [translate('pole')]: venda.NomePolo,
                        [translate('customerName')]: venda.Nome,
                        [translate('productName')]: item.NomeProduto,
                        [translate('quantity')]: quantidade,
                        [translate('unitValue')]: valorUnitario.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                        [translate('productValue')]: valorProduto.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                        [translate('shippingValue')]: valorFrete.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                        [translate('discountValue')]: (venda.TotalDesconto || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                        [translate('totalValue')]: venda.PrecoVendaCalculado.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                        [translate('discountformat')]: venda.DescontoFormatado || '-',
                        [translate('couponCode')]: venda.codigoCupom || '-',
                        [translate('saleDate')]: safeFormatDate(venda.Data),
                        [translate('statusSale')]: venda.StatusVenda,
                        [translate('formOfPayment')]: venda.FormaPagamento,
                        [translate('DatePayment')]: safeFormatDate(venda.DataConciliacao),
                        [translate('StatusPayment')]: venda.StatusPagamento,
                        [translate('typeOfSale')]: venda.EmExpedicao === true ? translate('expedition') : translate('sale'),
                        [translate('shipmentType')]: venda.TipoExpedicao === null
                            ? '-'
                            : (venda.TipoExpedicao ? translate('automatic') : translate('manual'))
                    });
                    currentRow++;
                });
            });

            exportToExcel(dataToExport, "Relatorio_Vendas", "Vendas", merges);
        } catch (error) {
            setIsExporting(false);
        } finally {
            dispatch(
                showAlert({
                    type: 'success',
                    message: translate('exportCompleted'),
                    time: 3000,
                }),
            );
            setIsExporting(false);
        }
    };

    return (
        <>
            <Helmet>
                <title>{translate('sales')}</title>
            </Helmet>

            <TitlePage title={translate('sales')} />

            <CardFilter>
                <div className="filter-grid">
                    <div className="boxSelectMulti col-span-2">
                        <SelectMulti
                            placeholder={translate('poles')}
                            options={inputPoles || []}
                            value={inputPoles?.filter(p => selectedPoles?.includes(p.value)) || []}
                            onChange={(selected) => {
                                const values = selected ? selected.map(s => s.value) : [];
                                setSelectedPoles(values);
                            }}
                        />
                    </div>

                    <div className="boxText col-span-2">
                        <Input
                            value={customerName}
                            label={translate('customerName')}
                            status={"couponStartDateStatus"}
                            change={(value) => setCustomerName(value)}
                        />
                    </div>

                    <div className="boxText col-span-2">
                        <InputCPFCNPJ
                            value={cpfCNPJ}
                            label="CPF/CNPJ"
                            status={"couponStartDateStatus"}
                            change={(value) => setCPFCNPJ(value)}
                        />
                    </div>
                    <div className="boxSelectMulti col-span-2">
                        <SelectMulti
                            placeholder={translate('saleStatus')}
                            options={inputSaleStatus || []}
                            value={inputSaleStatus?.filter(p => selectedStatus?.includes(p.value)) || []}
                            onChange={(selected) => {
                                const values = selected ? selected.map(s => s.value) : [];
                                setSelectedStatus(values);
                            }}
                        />
                    </div>

                    <div className="boxSelectMulti col-span-2">
                        <SelectMulti
                            placeholder="Status Pagamento"
                            options={inputPaymentStatus}
                            value={inputPaymentStatus.filter(p => selectedPaymentStatus.includes(p.value))}
                            onChange={(selected) => {
                                const values = selected ? selected.map(s => s.value) : [];
                                setSelectedPaymentStatus(values);
                            }}
                        />
                    </div>

                    <div className="boxText col-span-2">
                        <Input
                            value={orderCode}
                            type="number"
                            label={translate('orderCode')}
                            status={"couponStartDateStatus"}
                            change={(value) => setOrderCode(value)}
                        />
                    </div>

                    <div className="boxSelectOne col-span-1">
                        <SelectOne
                            label={translate('typeOfSale')}
                            options={inputSaleType}
                            value={selectedSaleType}
                            change={(option) => {
                                setSaleType(option.value);
                                setSelectedSaleType(option);
                                if (option.value === 0) {
                                    setShipmentType(inputShipmentType[0].value);
                                    setSelectedShipmentType(inputShipmentType[0]);
                                }
                            }}
                            searchable={true}
                        />
                    </div>

                    <div className="boxSelectOne col-span-1">
                        <SelectOne
                            label='Tipo Expedição'
                            options={saleType === 0 ? [inputShipmentType[0]] : inputShipmentType}
                            value={selectedShipmentType}
                            change={(option) => {
                                setShipmentType(option.value);
                                setSelectedShipmentType(option);
                            }}
                            searchable={true}
                            isDisabled={saleType === 0}
                        />
                    </div>

                    <div className="date-section">
                        <div className="boxFilter col-span-2">
                            {filters.map((item) => (
                                <div
                                    className={item.active ? "item active" : "item"}
                                    key={item.id}
                                    onClick={() => !item.active && handleFilter(item.id)}
                                >
                                    {item.active ? (
                                        <RiCheckboxCircleLine size={20} color={'#17c671'} />
                                    ) : (
                                        <RiCheckboxBlankCircleLine size={20} />
                                    )}
                                    <div className="description">{item.description}</div>
                                </div>
                            ))}
                        </div>

                        <div className="date-inputs-container col-span-2">
                            {filterCurrent?.id === 1 && (
                                <div className="boxSelectOne">
                                    <SelectOne
                                        label={translate('period')}
                                        options={inputDates}
                                        value={selectedDate}
                                        change={(option) => {
                                            setInitialDate(option.value);
                                            setSelectedDate(option);
                                        }}
                                        searchable={true}
                                    />
                                </div>
                            )}

                            {filterCurrent?.id === 2 && (
                                <div className="boxDate">
                                    <div className="date-picker-container">
                                        <DatePicker
                                            locale="pt"
                                            dateFormat="dd/MM/yyyy"
                                            selected={initialDate}
                                            maxDate={new Date()}
                                            placeholderText="Data Inicial"
                                            onChange={(e) => setInitialDate(e)}
                                            popperPlacement="bottom-start"
                                        />
                                    </div>
                                    <div className="de"> de </div>
                                    <div className="date-picker-container">
                                        <DatePicker
                                            locale="pt"
                                            dateFormat="dd/MM/yyyy"
                                            selected={endDate}
                                            maxDate={new Date()}
                                            placeholderText="Data Final"
                                            onChange={(e) => setEndDate(e)}
                                            popperPlacement="bottom-end"
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <div className="actions-container">
                    <div className="actions-left">
                        {salesPagination?.VendasFranqueadora?.length > 0 && (
                            <button
                                className="btn-export"
                                onClick={handleExport}
                                disabled={isExporting}
                            >
                                {isExporting ? translate('generatingSpreadsheet') : translate('exportToSpreadsheet')}
                            </button>
                        )}
                    </div>

                    <div className="boxActions">
                        <button
                            className="btn btn-filter btn-clear"
                            onClick={() => {
                                handleClearFilter();
                                setCurrentPage(1);
                            }}>
                            Limpar
                        </button>

                        <button
                            className="btn btn-primary btn-filter"
                            onClick={() => {
                                handleFetchPaginado(1);
                            }}>
                            Filtrar
                        </button>
                    </div>
                </div>
            </CardFilter>

            {!salesPaginationIsLoading && salesPagination?.VendasFranqueadora?.length > 0 && (
                <ContainerStats>
                    <CardStat>
                        <div className="content-left">
                            <div className="icon-box">
                                <RiShoppingCartLine size={22} />
                            </div>
                            <div className="info">
                                <span>{translate('orders')}</span>
                                <strong>{showValues ? TotalPedidos : '••••'}</strong>
                            </div>
                        </div>
                        <div onClick={() => setShowValues(!showValues)} style={{ cursor: 'pointer' }}>
                            {showValues ? <RiEyeLine className="action-icon" size={18} /> : <RiEyeOffLine className="action-icon" size={18} />}
                        </div>
                    </CardStat>

                    <CardStat>
                        <div className="content-left">
                            <div className="icon-box" style={{ background: '#eef5ff', color: '#5a8dee' }}>
                                <RiMoneyDollarCircleLine size={22} />
                            </div>
                            <div className="info">
                                <span>{translate('totalOrders')}</span>
                                <strong>{showValues ? formatCurrency(ValorTotalPedidos) : '••••'}</strong>
                            </div>
                        </div>
                        <div onClick={() => setShowValues(!showValues)} style={{ cursor: 'pointer' }}>
                            {showValues ? <RiEyeLine className="action-icon" size={18} /> : <RiEyeOffLine className="action-icon" size={18} />}
                        </div>
                    </CardStat>

                    <CardStat>
                        <div className="content-left">
                            <div className="icon-box">
                                <RiShoppingBagLine size={22} />
                            </div>
                            <div className="info">
                                <span>{translate('productsSold')}</span>
                                <strong>{showValues ? TotalProdutos : '••••'}</strong>
                            </div>
                        </div>
                        <div onClick={() => setShowValues(!showValues)} style={{ cursor: 'pointer' }}>
                            {showValues ? <RiEyeLine className="action-icon" size={18} /> : <RiEyeOffLine className="action-icon" size={18} />}
                        </div>
                    </CardStat>

                    <CardStat>
                        <div className="content-left">
                            <div className="icon-box">
                                <RiLineChartLine size={22} />
                            </div>
                            <div className="info">
                                <span>{translate('averageTicket')}</span>
                                <strong>{showValues ? formatCurrency(TicketMedio) : '••••'}</strong>
                            </div>
                        </div>
                        <div onClick={() => setShowValues(!showValues)} style={{ cursor: 'pointer' }}>
                            {showValues ? <RiEyeLine className="action-icon" size={18} /> : <RiEyeOffLine className="action-icon" size={18} />}
                        </div>
                    </CardStat>
                </ContainerStats>
            )}

            {salesPaginationIsLoading ? (
                <ContainerLoader>
                    <ContentLoader
                        width={'100%'}
                        speed={1}
                        height={'280px'}
                        backgroundColor={'#c6c6c6'}
                        foregroundColor={'#F0F0F5'}>
                        <rect x="0" y="0" rx="5px" ry="5px" width="100%" height="80px" />
                        <rect x="0" y="100" rx="5px" ry="5px" width="100%" height="80px" />
                        <rect x="0" y="200" rx="5px" ry="5px" width="100%" height="80px" />
                    </ContentLoader>
                </ContainerLoader>
            ) : (
                <>
                    {currentSales.length > 0 ? (
                        currentSales.map((item) => (
                            <ItemSales key={item.IdVenda} item={item} />
                        ))
                    ) : (
                        <div style={{ textAlign: 'center', padding: '40px', color: '#999' }}>
                            {translate('productsSold')}
                        </div>
                    )}
                </>
            )}

            {!salesPaginationIsLoading && salesPagination?.VendasFranqueadora?.length > 0 && totalPages > 1 && (
                <PaginationContainer>
                    <button
                        className="pagination-nav"
                        onClick={() => handleFetchPaginado(1)}
                        disabled={currentPage === 1 || salesPaginationIsLoading}
                    >
                        {"<<"}
                    </button>

                    <button
                        className="pagination-nav"
                        onClick={() => handleFetchPaginado(currentPage - 1)}
                        disabled={currentPage === 1 || salesPaginationIsLoading}
                    >
                        {"<"}
                    </button>

                    <div className="pagination-numbers">
                        {(() => {
                            const pages = [];
                            const maxVisible = 5;
                            let startPage = Math.max(1, currentPage - Math.floor(maxVisible / 2));
                            let endPage = Math.min(totalPages, startPage + maxVisible - 1);

                            if (endPage - startPage + 1 < maxVisible) {
                                startPage = Math.max(1, endPage - maxVisible + 1);
                            }

                            for (let i = startPage; i <= endPage; i++) {
                                pages.push(
                                    <button
                                        key={i}
                                        className={`pagination-number ${currentPage === i ? 'active' : ''}`}
                                        onClick={() => handleFetchPaginado(i)}
                                        disabled={salesPaginationIsLoading}
                                    >
                                        {i}
                                    </button>
                                );
                            }
                            return pages;
                        })()}
                    </div>

                    <button
                        className="pagination-nav"
                        onClick={() => handleFetchPaginado(currentPage + 1)}
                        disabled={currentPage === totalPages || salesPaginationIsLoading}
                    >
                        {">"}
                    </button>

                    <button
                        className="pagination-nav"
                        onClick={() => handleFetchPaginado(totalPages)}
                        disabled={currentPage === totalPages || salesPaginationIsLoading}
                    >
                        {">>"}
                    </button>
                </PaginationContainer>
            )}
        </>
    );
}

const ItemSales = ({ item }) => {
    const [open, setOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [detailsSale, setDetailsSale] = useState(null);
    const [txtTotalPaid, setTxtTotalPaid] = useState(null);

    useEffect(() => {
        setDetailsSale(null);
        if (open) {
            setIsLoading(true);
            apiLoja
                .get(`/Vendas/GetVendaById/${item.IdVenda}`)
                .then(function (response) {
                    setDetailsSale(response.data);
                    setIsLoading(false);
                })
                .catch(function (error) {
                    console.log(error);
                    setIsLoading(false);
                });
        }
    }, [open]);

    useEffect(() => {
        if (detailsSale != null) {
            let textoTotalPago = '';

            if (detailsSale.Entrada > 0) {
                textoTotalPago += `Entrada ${(
                    detailsSale.Entrada + detailsSale.Frete
                ).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} + `;
            }

            textoTotalPago += `${detailsSale.QtdeParcela
                }x ${detailsSale.ParcelaValor.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                })}`;

            setTxtTotalPaid(textoTotalPago);
        }
    }, [detailsSale]);

    function handleOpen() {
        if (!open) {
            setIsLoading(true);
            setDetailsSale(null);
        }
        setOpen(!open);
    }

    return (
        <ItemSale>
            <HeaderSales onClick={() => handleOpen()}>
                <div className="item">
                    <div className="titulo">{translate('order')}</div>
                    <div>{item.IdVenda}</div>
                </div>
                <div className="item">
                    <div className="titulo">{translate('pole')}</div>
                    <div>{item.NomePolo}</div>
                </div>
                <div className="item">
                    <div className="titulo">{translate('customerName')}</div>
                    <div>{item.Nome}</div>
                </div>
                <div className="item">
                    <div className="titulo">{translate('shippingValue')}</div>
                    <div>{item.Frete.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    })}</div>
                </div>
                <div className="item">
                    <div className="titulo">{translate('totalValue')}</div>
                    <div>
                        {item.PrecoVendaCalculado.toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL'
                        })}
                    </div>
                </div>
                <div className="item">
                    <div className="titulo">{translate('saleDate')}</div>
                    <div>
                        {item?.Data && !isNaN(new Date(item.Data).getTime())
                            ? format(
                                item.Data.includes('T')
                                    ? new Date(item.Data)
                                    : new Date(`${item.Data}T00:00:00`),
                                'dd/MM/yyyy HH:mm',
                                { locale: pt }
                            )
                            : '-'}
                    </div>
                </div>
                <div className="item">
                    <div className="titulo">{translate('statusSale')}</div>
                    <div>{item.StatusVenda}</div>
                </div>
                <div className="item">
                    <div className="titulo">Status Pagamento</div>
                    <div>{item.StatusPagamento || 'Não gerado'}</div>
                </div>
                <div className="item">
                    <div className="titulo">{translate('typeOfSale')}</div>
                    <div>
                        {item.EmExpedicao === true
                            ? `${translate('expedition')} (${item.TipoExpedicao ? translate('automatic') : translate('manual')})`
                            : translate('sale')
                        }
                    </div>
                </div>
                <div className="item-action">
                    <ArrowCollapse open={open}>
                        <RiArrowDropDownLine size={30} />
                    </ArrowCollapse>
                </div>
            </HeaderSales>
            <CollapseItem isOpen={open} transition={`height 0.4s cubic-bezier(.4, 0, .2, 1)`}>
                {isLoading ? (
                    <ContentLoader width={'100%'} speed={1} height={'280px'}>
                        <rect x="0" y="20" rx="5px" ry="5px" width="100%" height="40px" />
                        <rect x="0" y="80" rx="5px" ry="5px" width="100%" height="40px" />
                        <rect x="0" y="140" rx="5px" ry="5px" width="100%" height="40px" />
                        <rect x="0" y="200" rx="5px" ry="5px" width="100%" height="80px" />
                    </ContentLoader>
                ) : null}
                {item.TipoVenda.toLowerCase() === 'matricula' ? (
                    detailsSale ? (
                        <UserData item={detailsSale} />
                    ) : null
                ) : null}
                {item.TipoVenda.toLowerCase() === 'voucher' ? (
                    detailsSale ? (
                        <VoucherContainer>
                            <div className="header">VOUCHERS</div>
                            <div className="body">
                                {(detailsSale.Vouchers || []).map((item, index) => {
                                    return <Voucher key={index} item={item} />;
                                })}
                            </div>
                        </VoucherContainer>
                    ) : null
                ) : null}
                {detailsSale ? (
                    <>
                        <Installments>
                            <div className="header">{translate('installments')}</div>
                            <div>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>{translate('formOfPayment')}</th>
                                            <th>{translate('installments')}</th>
                                            <th>{translate('installmentValue')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(detailsSale.PagamentoParcelaViewModel || []).map((item) => (
                                            <tr key={item.IdPagamentoParcela}>
                                                <td>{item.FormaPagamento}</td>
                                                <td>{item.NumeroParcela}</td>
                                                <td>
                                                    {(item.Valor || 0).toLocaleString('pt-BR', {
                                                        style: 'currency',
                                                        currency: 'BRL',
                                                    })}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </Installments>
                        <Products>
                            <div className="header">{translate('products')}</div>
                            <div>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>{translate('product')}</th>
                                            <th>{translate('quantity')}</th>
                                            <th>{translate('value')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(detailsSale.VendaItem || []).map((item) => (
                                            <tr key={item.IdVendaItem}>
                                                <td>
                                                    <div className="box-prod">
                                                        <img
                                                            className="img-prod"
                                                            src={item.ImagemProduto}
                                                        />
                                                        {item.NomeProduto}
                                                        {item.IdDescontoProgressivo && Number(item.IdDescontoProgressivo) > 0 ? (
                                                            <span style={{ marginLeft: '8px' }}>
                                                                <Badge type="success">{item.NomeDescontoProgressivo || item.nomeDescontoProgressivo}</Badge>
                                                            </span>
                                                        ) : null}
                                                    </div>
                                                </td>
                                                <td>{item.Quantidade}</td>
                                                <td>
                                                    {(item.Preco || 0).toLocaleString('pt-BR', {
                                                        style: 'currency',
                                                        currency: 'BRL',
                                                    })}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </Products>
                        <FooterSale>
                            {detailsSale.VendaItem && (detailsSale.VendaItem || []).some(i => i.IdDescontoProgressivo && Number(i.IdDescontoProgressivo) > 0) && (
                                <div className="item">
                                    <div className="title-item">{translate('progressiveDiscount') || 'Desconto Progressivo'}</div>
                                    <div>
                                        {(detailsSale.VendaItem || []).reduce((acc, curr) => {
                                            const itemDiscId = curr.IdDescontoProgressivo ? Number(curr.IdDescontoProgressivo) : 0;
                                            if (itemDiscId > 0) {
                                                return acc + (Number(curr.DescontoProgressivoCalculado) || 0);
                                            }
                                            return acc;
                                        }, 0).toLocaleString('pt-BR', {
                                            style: 'currency',
                                            currency: 'BRL',
                                        })}
                                    </div>
                                </div>
                            )}
                            <div className="item">
                                <div className="title-item">% {translate('discount')}(-)</div>
                                <div>{detailsSale.PorcentagemDesconto || 0}</div>
                            </div>
                            <div className="item">
                                <div className="title-item">% {translate('interest')}(+)</div>
                                <div>{detailsSale.PorcentagemJuros || 0}</div>
                            </div>
                            <div className="item">
                                <div className="title-item">{translate('dispatch')}(+)</div>
                                <div>
                                    {(detailsSale.Frete || 0).toLocaleString('pt-BR', {
                                        style: 'currency',
                                        currency: 'BRL',
                                    })}
                                </div>
                            </div>
                            <div className="item total-pago">
                                <div className="title-item">{translate('totalPaid')}</div>
                                <div>{txtTotalPaid}</div>
                            </div>
                        </FooterSale>
                    </>
                ) : null}
            </CollapseItem>
        </ItemSale>
    );
};

const UserData = ({ item }) => {
    const { VendaUsuarioDados } = item;

    if (item.VendaUsuarioDados == null) {
        return null;
    }

    if (VendaUsuarioDados.ResponsavelDataNascimento === '0001-01-01T00:00:00') {
        return (
            <>
                <StudentContainer>
                    <div className="header">DADOS ALUNO</div>
                    <div className="body">
                        <div className="item">
                            <div className="title-item">NOME</div>
                            <div className="content-item">{VendaUsuarioDados.AlunoNome}</div>
                        </div>
                        <div className="item">
                            <div className="title-item">CPF</div>
                            <div className="content-item">{VendaUsuarioDados.AlunoCPF}</div>
                        </div>
                        <div className="item">
                            <div className="title-item">EMAIL</div>
                            <div className="content-item">{VendaUsuarioDados.AlunoEmail}</div>
                        </div>
                        <div className="item">
                            <div className="title-item">Telefone</div>
                            <div className="content-item">{VendaUsuarioDados.AlunoTelefone}</div>
                        </div>
                        <div className="item">
                            <div className="title-item">Celular</div>
                            <div className="content-item">{VendaUsuarioDados.AlunoCelular}</div>
                        </div>
                    </div>
                </StudentContainer>
            </>
        );
    } else {
        return (
            <>
                <StudentContainer>
                    <div className="header">DADOS ALUNO</div>
                    <div className="body">
                        <div className="item">
                            <div className="title-item">NOME</div>
                            <div className="content-item">{VendaUsuarioDados.AlunoNome}</div>
                        </div>
                        <div className="item">
                            <div className="title-item">CPF</div>
                            <div className="content-item">{VendaUsuarioDados.AlunoCPF}</div>
                        </div>
                        <div className="item">
                            <div className="title-item">EMAIL</div>
                            <div className="content-item">{VendaUsuarioDados.AlunoEmail}</div>
                        </div>
                    </div>
                </StudentContainer>

                <ResponsibleContainer>
                    <div className="header">DADOS RESPONSÁVEL</div>
                    <div className="body">
                        <div className="item">
                            <div className="title-item">NOME</div>
                            <div className="content-item">{VendaUsuarioDados.ResponsavelNome}</div>
                        </div>
                        <div className="item">
                            <div className="title-item">CPF</div>
                            <div className="content-item">{VendaUsuarioDados.ResponsavelCPF}</div>
                        </div>
                        <div className="item">
                            <div className="title-item">RG</div>
                            <div className="content-item">{VendaUsuarioDados.ResponsavelRG}</div>
                        </div>
                        <div className="item">
                            <div className="title-item">EMAIL</div>
                            <div className="content-item">{VendaUsuarioDados.ResponsavelEmail}</div>
                        </div>
                        <div className="item">
                            <div className="title-item">TELEFONE</div>
                            <div className="content-item">
                                {VendaUsuarioDados.ResponsavelTelefone}
                            </div>
                        </div>
                        <div className="item">
                            <div className="title-item">CELULAR</div>
                            <div className="content-item">
                                {VendaUsuarioDados.ResponsavelCelular}
                            </div>
                        </div>
                    </div>
                </ResponsibleContainer>
            </>
        );
    }
};

const safeFormatDate = (dateValue) => {
    if (!dateValue) return '-';

    let parsedDate = dateValue instanceof Date ? dateValue : null;

    if (typeof dateValue === 'string') {
        if (/^\d{4}-\d{2}-\d{2}$/.test(dateValue)) {
            parsedDate = new Date(`${dateValue}T00:00:00`);
        } else {
            parsedDate = parseISO(dateValue);
        }
    }

    if (typeof dateValue === 'number') {
        parsedDate = new Date(dateValue);
    }

    if (parsedDate && isValid(parsedDate) && parsedDate.getFullYear() > 1990) {
        return format(parsedDate, 'dd/MM/yyyy HH:mm');
    }

    return '-';
};

export default Sales;
